export type CopilotState = {
  isLoading: boolean;
  isTyping: boolean;
  replies: Array<string>;
  sampleQuestions: Array<string>;
  messages: Array<Message>;
  threadId: string;
  clientId: string;
  showMenu: boolean;
  toastText: string;
  showToast: boolean;
  newSession: boolean;
  socket: WebSocket | null;
  isCopilotOpen: boolean;
  retry: number;
  isRecording?: boolean;
  agentAI?: boolean;
  agentAIContext?: any;
  status?: {
    type: 'success' | 'error' | 'info';
    message: string;
    duration?: number;
  } | null;
  uploadedFile?: File | null;
  workflowMetaData?: any;
  summariseData?: string;
  lastUpdated?: number | null;
};

export type Cta = {
  type: string;
  title: string;
  meta_data?: any;
};

export type Message = {
  sender: string;
  text: string;
  message_type: string;
  leads_data?: ILead[];
  tabular_data?: string[][];
  ctas?: Cta[];
  metadata?: any;
  file_data?:
    | {
        type: string;
        file: any;
      }
    | undefined;
};

export type ILead = {
  lead_name: string;
  lead_code: string;
};

export const MESSAGE_TYPE = {
  TEXT: 'TEXT',
  TABLE: 'TABLE',
  LEADS: 'LEADS',
};

export const SENDER = {
  AI: 'AI',
  USER: 'USER',
};

export type HistoryPayload = {
  thread_id: string;
  client_id: string;
};

export type CopilotVersion = 'default' | 'workflow';
